import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// @ts-expect-error untyped component
import CountrySelect from 'ui-addon-i18n/components/CountrySelect';
import { setErrorMessages, getShowAllErrors } from '../../state/errorMessagesSlice';
import { useGetErrorMessagesAndTranslations } from '../../hooks/useGetErrorMessagesAndTranslations';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CountryInput({
  validCountries,
  value,
  onChange,
  disabled,
  isShippingAddress = false
}) {
  const dispatch = useDispatch();
  const showAllErrors = useSelector(getShowAllErrors);
  const [hasBeenBlurred, setHasBeenBlurred] = useState(false);
  const isError = (hasBeenBlurred || showAllErrors) && !value;
  useEffect(() => {
    dispatch(setErrorMessages({
      [`empty${isShippingAddress ? 'Shipping' : 'Billing'}Country`]: {
        isError
      }
    }));
  }, [dispatch, isError, isShippingAddress]);
  const errorMessage = useGetErrorMessagesAndTranslations().get('emptyCountry');
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payments.fullAddress.country"
    }),
    required: true,
    error: isError,
    validationMessage: isError && errorMessage,
    children: /*#__PURE__*/_jsx(CountrySelect, {
      "data-test-id": "country-input",
      validCountries: validCountries,
      value: value,
      onChange: onChange,
      disabled: disabled,
      buttonUse: "form-on-dark",
      onBlur: () => setHasBeenBlurred(true)
    })
  });
}